import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { log } from '../../../services/utils';

import { ReactComponent as LogoIcon } from './logo.svg';

import styles from './logo.module.css';

const Logo = ( {
	className,
	labelled,
	...props
} ) => {
	return (
		<div
			className={ `${ styles.container } ${ className }` }
			{ ...props }
		>
			{ log( '- logo' ) }
			<LogoIcon className={ styles.logo } />
			{ labelled
				? <div className={ styles.title }>
					<h1>NORA</h1>
					<h5>Welcome to NORA</h5>
				</div>
				: null
			}
		</div>
	);
};

Logo.propTypes = { className: PropTypes.string, labelled: PropTypes.bool };

export default memo( Logo );
